<template>
  <div style="width: 46.875rem;height: 100%;">
    <video
      v-if="isSHow==true"
      id="myVideo"
      class="video-js vjs-default-skin vjs-big-play-centered vjs-progress-holder"
      ref="viodeRef"
      poster
      style="width: 100%;height: 100%;"
    ></video>
    <div v-if="isSHow!=true" id="common-video" class="h-100">
      <div class="h-100">
        <video
          x5-playsinline
          style="width: 100%;height: 100%;"
          ref="myVideo"
          :poster="poster"
          :src="videoSrc"
          controls
          preload="auto"
          oncontextmenu="return false"
          @timeupdate="timeupdate"
          controlslist="nodownload"
          class="video-box"
        ></video>
        <img
          src="@/assets/images/icon_play.png"
          alt
          @click="operateVideo"
          class="pointer operate-btn"
          :class="{ 'fade-out': videoState }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { postAction } from '@/api/api'
import { addVisitNum, dockingList, science } from '../api/url.js'

export default {
  name: 'CommonVideo',
  data() {
    return {
      myPlayer: '', //播放器
      videoUrl: 'http://cctvalih5ca.v.myalicdn.com/live/cctv1_2/index.m3u8',

      isSHow: true,
      videoState: false, // 视频播放状态
      // 学时
      studyTime: {
        currentTime: 0, // 当前已学时长
        duration: 0, // 总时长
      },
      videoSrc: '',
      // onlineNum: 0,
      timer: {}, // 定时器
      pauseTimer: {}, // 暂停定时器,
    }
  },
  /**
   * @param poster 展示图
   * @param src 视频资源
   * @param controls 是否显示控件
   * @param control 控件控制
   * @param videoData 视频基础数据
   */

  props: {
    poster: {
      type: String,
      required: false,
      default: '',
    },
    src: {
      type: String,
      required: true,
    },
    controls: {
      type: Boolean,
      required: false,
      default: true,
    },
    control: {
      type: Boolean,
      required: false,
      default: false,
    },
    // videoData: {
    // 	type: Object,
    // 	required: true
    // },
    ID: {
      type: Number,
    },
    onlineNum: {
      type: Number,
    },
    haveonline: {
      type: Boolean,
    },
  },
  created() {
    this.getvediodata()
  },
  mounted() {},
  beforeDestroy: function () {
    if (this.isSHow == true) {
      const videoDom = this.$refs.viodeRef //不能用document 获取节点
      this.$video(videoDom).dispose()
    }
    //离开页面销毁video实例，避免出现节点不存在 但是flash一直在执行，报 this.el.......is not function
  },
  methods: {
    getvediodata() {
      let vm = this
      let data = {
        action: 'Get_TechnologyActivity',
        ID: this.$route.query.id,
      }
      postAction(science, this.$qs.stringify(data)).then((res) => {
        // console.log('科技活动详情页', res)
        if (res[0].Online != '' && res[0].Status == 1 ) {
          this.isSHow = true
          this.myPlayer = this.$video(
            myVideo,
            {
              controls: true, //启动视频播放的唯一方法是使用autoplay属性或通过Player /v1。
              autoplay: false, //自动播放属性,muted:静音播放 muted
              preload: 'auto', //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
              sources: [
                {
                  src: res[0].Online,
                  type: 'application/x-mpegURL',
                },
              ],
            },
            function () {}
          )
        } else {
          this.isSHow = false
          this.videoSrc = res[0].VideoUrl
        }
      })
    },

    // 开启定时器
    openTimer() {
      this.timer = setInterval(() => {
        this.$emit('videoStudyTime', this.studyTime)
      }, 5000)
    },
    // 关闭定时器
    closeTimer() {
      clearInterval(this.timer)
      this.$emit('videoStudyTime', this.studyTime)
    },
    // 开启暂停定时器
    openPauseTimer() {
      this.pauseTimer = setInterval(() => {
        this.hintOperate()
      }, 600000)
    },
    // 关闭暂停定时器
    closePauseTimer() {
      clearInterval(this.pauseTimer)
    },
    // 提示操作
    hintOperate() {
      this.operateVideo()
      this.$alert('请点击确认继续学习', '提示', {
        confirmButtonText: '确定',
        confirmButtonClass: 'hint-btn',
        showClose: false,
        callback: (action) => {
          this.$refs.myVideo.currentTime = this.videoData.currentTime
          this.operateVideo()
          this.openPauseTimer()
        },
      })
    },
    // 获取当前播放位置
    timeupdate(e) {
      this.studyTime.currentTime = e.target.currentTime
      this.studyTime.duration = e.target.duration ? e.target.duration : 0
    },
    // 操作视频播放、暂停
    // 操作视频播放、暂停
    operateVideo() {
      //mp4
      if (this.$refs.myVideo.paused) {
        this.$refs.myVideo.play()
        this.videoState = true
      } else {
        this.$refs.myVideo.pause()
        this.videoState = false
      }
    },
    operateEvent() {
      //直播
      if (this.$refs.viodeRef.paused) {
        this.$refs.viodeRef.play()
      } else {
        this.$refs.viodeRef.pause()
      }
    },
  },
}
</script>

<style lang="scss">
video {
  object-fit: fill;
}

#common-video {
  position: relative;

  .video-box {
    box-sizing: border-box;
    border: 0;
    display: block;
    width: 100%;
    // height: 100%;
    /* height: 213px; */
    height: 25.3125rem;
    outline: none !important;
  }

  .isShow {
    //进度条
    video::-webkit-media-controls-timeline {
      display: none;
    }
  }

  video::-webkit-media-controls-play-button {
    visibility: hidden;
  }

  .operate-btn {
    // display: none !important;
    width: 60px;
    height: 60px;
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
  }

  /*.operate-btn:hover {*/
  /*opacity: 0.8;*/
  /*}*/
  .fade-out {
    opacity: 0;
  }
}

.play {
  width: 5rem;
  position: absolute;
  top: 38%;
  left: 47%;
  z-index: 999;
}
</style>
